module.exports = __webpack_public_path__ + "img/cancel-hen.96027b9f.png";